<template>
  <div class="blog-widget">
    <widget-link
      v-for="item in blogListLocale"
      :key="item.id"
      :item="item"
    ></widget-link>
  </div>
</template>

<script>
  import WidgetLink from '~/components/menu/WidgetLink'

  const blogList = {
    en: [
      {
        title: 'Migrating from AWS to Russian Provider',
        externalTypeOfLink: true,
        url: {
          path: 'https://blog.selectel.com/case-ostrovok/',
          hash: null
        },
        labels: [
          {
            iconName: 'clock',
            name: '6 August 2020'
          }
        ],
        description: null
      },
      {
        title: 'Incremental Backups in Proxmox VE with VBR',
        externalTypeOfLink: true,
        url: {
          path: 'https://blog.selectel.com/backups-in-proxmox-ve/',
          hash: null
        },
        labels: [
          {
            iconName: 'clock',
            name: '10 July 2020'
          }
        ],
        description: null
      },
      {
        title: 'The Fifth Generation',
        externalTypeOfLink: true,
        url: {
          path: 'https://blog.selectel.com/the-fifth-generation/',
          hash: null
        },
        labels: [
          {
            iconName: 'clock',
            name: '30 June 2020'
          }
        ],
        description: null
      }
    ],
    ru: [
      {
        title: 'Установка и&nbsp;настройка Postfix и&nbsp;Dovecot на&nbsp;Ubuntu&nbsp;20.04',
        externalTypeOfLink: true,
        url: {
          path: 'https://selectel.ru/blog/postfix-dovecot-ubuntu/',
          hash: null
        },
        labels: [
          {
            iconName: 'clock',
            name: '22 апреля 2021'
          }
        ],
        description: null
      },
      {
        title: 'Неубиваемый солдат: как работает новый балансировщик нагрузки',
        externalTypeOfLink: true,
        url: {
          path: 'https://selectel.ru/blog/lbaas/',
          hash: null
        },
        labels: [
          {
            iconName: 'clock',
            name: '22 апреля 2021'
          }
        ],
        description: null
      },
      {
        title: 'Платформа Playkey: как стать Uber в&nbsp;мире отечественного клаудгейминга',
        externalTypeOfLink: true,
        url: {
          path: 'https://selectel.ru/blog/playkey/',
          hash: null
        },
        labels: [
          {
            iconName: 'clock',
            name: '21 апреля 2021'
          }
        ],
        description: null
      }
    ]
  }

  export default {
    name: 'BlogWidget',
    components: {WidgetLink},
    data() {
      return {
        blogList
      }
    },
    computed: {
      blogListLocale() {
        return this.blogList[this.$i18n.locale]
      }
    }
  }
</script>